/* Totem - scroll smoothness, September 2026 ("No Flinches").
   Behaviour is unchanged: the button still appears once the page is more than
   450px down and still waits 200ms after scrolling stops before it changes, so
   it looks and feels exactly as before.

   What changed: the old version called clearTimeout + setTimeout on EVERY
   scroll event (162 timer churns during a 3.5s fast scroll) and re-applied the
   class every time. Now the listener is explicitly passive, one timer is
   reused, and the class is only touched when the state actually flips. */
if (!customElements.get('back-to-top')) {
	customElements.define('back-to-top', class ButtonScrollTop extends HTMLElement {
		constructor() {
			super();
			this.button = this.querySelector('.back-to-top');

			if (!this.button) {
				return;
			}

			this.timeout = null;
			this.visible = false;

			this.settle = () => {
				this.timeout = null;
				const shouldShow = window.scrollY > 450;
				if (shouldShow === this.visible) {
					return;
				}
				this.visible = shouldShow;
				if (shouldShow) {
					this.button.classList.add('back-to-top-visible');
				} else {
					this.button.classList.remove('back-to-top-visible');
				}
			};

			window.addEventListener('scroll', () => {
				if (this.timeout !== null) {
					clearTimeout(this.timeout);
				}
				this.timeout = setTimeout(this.settle, 200);
			}, { passive: true });

			this.button.addEventListener('click', (event) => {
				event.preventDefault();
				this.handleClick();
			});
		}

		handleClick() {
			document.documentElement.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
	});
}
